export enum Sizes {
  ExtraSmall = 'xs',
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  ExtraLarge = 'xl',
}

export const Thicknesses = {
  [Sizes.ExtraSmall]: '2px',
  [Sizes.Small]: '2px',
  [Sizes.Medium]: '3px',
  [Sizes.Large]: '3px',
  [Sizes.ExtraLarge]: '4px',
}
